module.exports = __webpack_public_path__ + "img/sportlandniederoesterreich-logo-rgb-png.9f207a28.png";